export default __webpack_public_path__ + "static/media/aple.69cfe4f2.png";